// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FloorsResponse } from '../../../../floors/models/floor';
import { DateRangeFilter } from '@coa/app/shared/filters/select-date-range/models/date-range-filter';
import { ConfigService } from '@coa/app/core/services/config.service';
import { StoresAggregationType } from '@coa/app/shared/filters/select-aggregation/models/dateRangeFilter';

@Injectable({
  providedIn: 'root',
})
export class DashboardFloorsService {

  constructor(private http: HttpClient,
              private configService: ConfigService) {
  }

  floors(clientId: string, timePeriod: DateRangeFilter, page: number, categoryId: string): Observable<FloorsResponse> {
    const url = this.configService.getConfig().analyticsApi + '/aggregates';
    let params = new HttpParams()
      .set('clientId', clientId.toString())
      .set('timePeriod', timePeriod)
      .set('page', page.toString())
      .set('aggregationType', StoresAggregationType.LOCATIONS_AND_FLOORS)
      .set('size', '3');

    if (categoryId) {
      params = params
        .set('categoryId', categoryId.toString());
    }
    return this.http.get<FloorsResponse>(url, {params});
  }
}
